<template>
  <div class="search-source">
    <div class="mt-3 bg-white border-top border-bottom p-2">
      <p class="text-primary m-0 d-flex justify-content-between"><!--@click="open=!open"-->
        {{hebrew ? 'מקורות' : 'Sources'}}<!-- 
        <i v-if="open" class="fas fa-caret-down"></i>
        <i v-else class="fas fa-caret-up"></i> -->
      </p>
      <b-form-group class="mb-0" v-if="open">
        <b-form-radio-group class="mb-0" v-model="displayBible">
          <b-form-radio  @change="setBible(true)" name="display-options" :value="displayBible">
            {{hebrew ? 'תנ"ך' : 'Bible'}} <small class="text-muted" v-if="complete">({{bibleResults}} מילים, {{bibleSentencesCount}} מופעים)</small>
          </b-form-radio>
          <b-form-radio  @change="setBible(false)" name="display-options" :value="!displayBible">
            {{hebrew ? 'תלמוד' : 'Talmud'}}  <small class="text-muted" v-if="complete">({{talmudResults}} מילים, {{talmudSentencesCount}} מופעים)</small></b-form-radio>
        </b-form-radio-group>      
      </b-form-group>
    </div>     
  </div>
</template>

<script>
//import {Actions} from '@/store/stateChanges'

export default {
  name: 'SearchSource',
  data() {
    return {
      displayBible: true,
      open: true
    }
  },
  props: [],
  methods: {
    setBible(show) {
     this.$store.commit('SET_BIBLE', show)
     this.$store.commit('SET_TALMUD', !show)
     this.displayBible = show
     this.$store.commit('SET_CURRENT_INDEX',  0)
     this.removeHeightAuto()
    },
    removeHeightAuto () {
      var elems = document.querySelectorAll("li.h-auto");
      [].forEach.call(elems, function(el) {                    
        el.classList.remove("h-auto");
      }) 
    },         
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    complete () {
      return this.$store.state.searchApiState === 'Complete'
    },
    bibleResults () {
      return this.$store.state.bibleSearchApiResponse.length
    },
    talmudResults () {
      return this.$store.state.talmudSearchApiResponse.length
    },
   bibleSentencesCount () {
      return this.$store.state.totalBibleCount
    },
    talmudSentencesCount () {
      return this.$store.state.totalTalmudCount
    },
  }
}
</script>
<style>
  .custom-control.custom-radio {
    display: block;
    padding-right: 8px!important;
  }
</style>
<style scoped>
  i {line-height: 23px;}
</style>
